import "./App.css";
import TicTacToe from "./components/TicTacToe";
function App() {
  return (
    <div className="App">
      <TicTacToe />
    </div>
  );
}

export default App;
